export default __webpack_public_path__ + "static/tr-009996bfa350133ea7d10a1ce9fd2658.png";